<template>
    <div>

        <div class="wrapper">
            <div class="div-form">

                <div class="mb-4"><img src="/images/logo.png" alt="Leonards Studio" style="opacity:75%; width:140px;"></div>

                <div v-if="display.loading">
                    <div class="lds-ripple"><div></div><div></div></div>
                </div>

                <div v-if="display.loginForm">
                    <form autocomplete="on" @submit.prevent="login" method="post" id="loginForm" name="loginForm">

                        <div v-if="errors.loginForm" class="alert alert-danger my-3" role="alert">
                            {{ errors.loginForm }}
                        </div>
                        <div class="input-group my-3 border rounded-lg">
                            <div class="input-group-prepend">
                                <div class="input-group-text"><i class="fas fa-envelope"></i></div>
                            </div>
                            <input type="email"
                            id="username" name="username"
                            class="form-control font-weight-bold bg-white"
                            style="font-size:1rem;"
                            v-model="username"
                            :style="username.length>26 ? 'font-size:0.8rem;' : 'font-size:1rem;'"
                            placeholder="Email"
                            autocomplete="username"

                            autofocus required>
                        </div>
                        <div class="input-group my-3 border rounded-lg">
                            <div class="input-group-prepend">
                                <div class="input-group-text"><i class="fas fa-lock"></i></div>
                            </div>
                            <input type="password"
                            id="password"
                            name="password"
                            class="form-control font-weight-bold bg-white"
                            style="font-size:1rem;"
                            placeholder="Password"
                            v-model="password"
                            autocomplete="password"
                            required>
                        </div>

                        <div class="my-3">
                            <button type="submit" class="btn btn-primary w-100 font-lg" :disabled="display.loading">
                                Sign in
                            </button>
                        </div>

                        <div class="mt-2">
                            <small>
                                <router-link :to="{ name: 'forgot-password' }" class="forgot-password">Forgot password?</router-link>
                            </small>
                        </div>

                    </form>
                </div>

                <div v-if="display.authCodeForm">
                    <form autocomplete="off" @submit.prevent="verify" method="post" id="verifyForm" name="verifyForm">

                        <div class="my-3">
                            <div class="font-weight-bold" style="font-size:1.2rem;color:#555;">Two-Factor Authentication</div>
                        </div>

                        <div v-if="errors.verifyForm" class="alert alert-danger my-3" role="alert">
                            {{ errors.verifyForm }}
                        </div>

                        <div v-if="errors.tooManyAttempts" class="my-2"><a href="/login">Try Again</a></div>

                        <div v-if="!errors.tooManyAttempts">
                            <div class="input-group my-3 border rounded-lg">
                                <div class="input-group-prepend">
                                    <div class="input-group-text"><i class="fas fa-key"></i></div>
                                </div>
                                <input type="text"
                                id="code" name="code"
                                class="form-control font-weight-bold bg-white text-center"
                                style="font-size:1rem;"
                                placeholder="Verification Code"
                                v-model="code"
                                required>
                            </div>
                            
                            <div class="my-3">
                                <button type="submit" class="btn btn-primary w-100 font-lg" :disabled="display.loading">
                                    Verify
                                </button>
                            </div>

                            <div class="my-2"><small>The verification code has been sent to<br><b>{{ authCode.email }}</b></small></div>
                        </div>
                        
                    </form>
                </div>

                <div v-if="display.success">
                    <!-- <div class="my-2 py-2 px-4 bg-success text-white rounded-lg" style="font-size: 1.1rem;">Successfully Logged In</div> -->
                    <div class="my-2 text-success" style="font-size: 1.2rem;">Successfully Logged In</div>
                </div>
                

            </div>
        </div>

    </div>
</template>


<script>
    import User from '../classes/User'
    // import VerifyEmail from '../components/VerifyEmail'

    export default {
        data() {
            return {
                username: '',
                password: null,
                code: null,
                errors: {
                    loginForm: null,
                    verifyForm: null,
                    tooManyAttempts: false,
                },
                redirectUrl: '/digitalId',
                currentDomain: null,
                
                authCode: {
                    email: null,
                    code_uuid: null,
                },
                display: {
                    loading: false,
                    success: false,
                    loginForm: true,
                    authCodeForm: false,
                }

            }
        },

        created() {
        },

        async mounted() {
            this.currentDomain = window.location.hostname;
            
            localStorage.removeItem('auth-token');
        },

        methods: {

            async login() {
                this.display.loginForm = false;
                this.display.loading = true;

                localStorage.removeItem('auth-token');

                try {
                    const response = await axios.post('auth/login', {
                        username: this.username,
                        password: this.password
                    });
                    
                    this.display.loading = false;
                    
                    if (response.data.auth_code == true && response.data.email && response.data.code_uuid) { // Need 2FA
                        this.authCode.email = response.data.email;
                        this.authCode.code_uuid = response.data.code_uuid;
                        this.display.loading = false;
                        this.display.authCodeForm = true;
                    } else if (response.data.jwt) { // 2FA not needed / Set jwt / Log in / Redirect
                        this.loginProcess(response.data.jwt);

                    } else { 
                        throw new Error('Something went wrong...');
                    }

                } catch (error) {
                    this.errors.loginForm = error.response.data.error ?? error;
                    this.display.loading = false;
                    this.display.loginForm = true;
                }

            },

            async verify() {
                this.display.authCodeForm = false;
                this.display.loading = true;

                try {
                    const response = await axios.post('auth/verifyCode', {
                        code: this.code,
                        code_uuid: this.authCode.code_uuid
                    });
                    this.display.loading = false;

                    if (response.data.jwt) {
                        this.loginProcess(response.data.jwt);
                    } 

                } catch(error) {
                    this.errors.verifyForm = error.response.data.error ?? error.response.data.errors.code[0] ?? error;
                    if (error?.response?.data?.many_attempts) {
                        this.errors.tooManyAttempts = true;
                    }
                    this.display.loading = false;
                    this.display.authCodeForm = true;
                }
            },

            loginProcess(jwt) {
                this.$auth.token(null, jwt, false);
                this.$auth.login({staySignedIn:true});
                sessionStorage.removeItem('auth-token');
                this.display.loading = false;
                this.display.success = true;

                this.redirectUrl = localStorage.getItem('auth-redir') ?? '/dashboard';
                localStorage.removeItem('auth-redir');
                
                window.location.href = this.redirectUrl;
            },

        },

        watch: {
            // '$route': function(to, from) {
            //     to.hash === '#verify' ? this.emailNotVerified = true : this.emailNotVerified = false;
            // }
        }
    }
</script>

<style scoped>

@import url('https://fonts.googleapis.com/css2?family=Roboto+Mono:ital,wght@0,400;0,600;1,300&display=swap');

.wrapper {
    position: relative;
    height: 100vh;
}
.div-form {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 20px;
    width:360px;
    text-align: center;
}

input {
    font-family: 'Roboto Mono', monospace;
    font-weight: 600;
    min-height: 38px;
}
input::placeholder {
  color: #999;
  font-weight: 400;
  /* font-style: italic; */
  font-size: 0.9rem;
}
input:focus {
    
    outline: 0;
    box-shadow: 0 0 0 0 #ffffff;
}

.forgot-password:hover {
    text-decoration: none;
}

.lds-ripple {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.lds-ripple div {
  position: absolute;
  border: 4px solid #555555;
  opacity: 1;
  border-radius: 50%;
  animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
}
.lds-ripple div:nth-child(2) {
  animation-delay: -0.5s;
}
@keyframes lds-ripple {
  0% {
    top: 36px;
    left: 36px;
    width: 0;
    height: 0;
    opacity: 0;
  }
  4.9% {
    top: 36px;
    left: 36px;
    width: 0;
    height: 0;
    opacity: 0;
  }
  5% {
    top: 36px;
    left: 36px;
    width: 0;
    height: 0;
    opacity: 1;
  }
  100% {
    top: 0px;
    left: 0px;
    width: 72px;
    height: 72px;
    opacity: 0;
  }
}

    
</style>
